import { render, staticRenderFns } from "./auditSubmit.vue?vue&type=template&id=2ba1d803"
import script from "./auditSubmit.vue?vue&type=script&lang=js"
export * from "./auditSubmit.vue?vue&type=script&lang=js"
import style0 from "./auditSubmit.vue?vue&type=style&index=0&id=2ba1d803&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports